var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-3" },
    [
      _c("div", { attrs: { id: "menu" } }, [
        _c("div", { staticClass: "sticky-top bg-white" }, [
          _c("nav", { staticClass: "small" }, [
            _c("ol", { staticClass: "breadcrumb pb-0" }, [
              _c("li", { staticClass: "breadcrumb-item" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("Menu")]
                ),
              ]),
              _c("li", { staticClass: "breadcrumb-item" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("back")
                      },
                    },
                  },
                  [_vm._v("Components")]
                ),
              ]),
              _c("li", { staticClass: "breadcrumb-item active" }, [
                _vm._v(_vm._s(_vm.rootComponent.componentId.tagName)),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-start mx-n3 p-2 border-bottom mb-3",
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("back")
                    },
                  },
                },
                [_c("i", { staticClass: "far fa-chevron-left fa-1x fa-fw" })]
              ),
              _c("h5", { staticClass: "m-0 p-0" }, [
                _vm._v(_vm._s(_vm.rootComponent.componentId.tagName)),
              ]),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "card mb-4" }, [
        _c("h5", { staticClass: "card-header" }, [
          _vm._v(
            "Linked " +
              _vm._s(
                `${_vm.linkType[0].toUpperCase()}${_vm.linkType.slice(1)}`
              ) +
              " Components"
          ),
        ]),
        _vm.linkedComponents.length
          ? _c(
              "div",
              { staticClass: "list-group list-group-flush" },
              [
                _c(
                  "draggable",
                  {
                    model: {
                      value: _vm.linkedComponents,
                      callback: function ($$v) {
                        _vm.linkedComponents = $$v
                      },
                      expression: "linkedComponents",
                    },
                  },
                  _vm._l(_vm.linkedComponents, function (cmp) {
                    return _c(
                      "div",
                      {
                        key: cmp._id,
                        staticClass:
                          "list-group-item d-flex justify-content-between align-items-center cursor-move align-items-center",
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", [
                            _c("i", { staticClass: "far fa-bars mr-2" }),
                          ]),
                          _c("div", [
                            _c("a", [_vm._v(_vm._s(cmp.componentId.tagName))]),
                            _c("div", { staticClass: "small" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cmp.description) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", [
                          _c("a", [
                            _c("i", {
                              staticClass:
                                "far fa-trash text-primary float-right",
                              on: {
                                click: function ($event) {
                                  return _vm.removeComponent(cmp._id)
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            )
          : _c("div", { staticClass: "card-body" }, [_vm._v("None assigned")]),
      ]),
      _c("top-table", {
        ref: "table",
        staticClass: "table-sm",
        attrs: {
          method: "post",
          requestFunction: _vm.requestFunction,
          keepInGlobalStore: false,
          tabFilterClass: ["col-6 pb-2 pt-2"],
          url: `/store/components/by-store/${_vm.storeId}`,
          "tab-filters": [
            { val: "isGlobal", criteria: ["Yes", "No"], selected: ["Yes"] },
          ],
          columns: ["componentId.tagName", "description", "toAdd"],
          sortable: ["description"],
          headings: {
            "componentId.tagName": "Name",
            description: "Description",
            toAdd: "Add",
          },
          overlap: true,
        },
        scopedSlots: _vm._u([
          {
            key: "componentId.tagName",
            fn: function (props) {
              return _c("div", { staticClass: "nav-link" }, [
                _c("span", [_vm._v(_vm._s(props.row.componentId.tagName))]),
              ])
            },
          },
          {
            key: "toAdd",
            fn: function (props) {
              return _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addComponent(props.row)
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                    },
                    [_vm._v("Link")]
                  ),
                ]
              )
            },
          },
        ]),
      }),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", disabled: _vm.loading },
          on: {
            click: function ($event) {
              return _vm.$emit("linkComponent", _vm.linkedComponents)
            },
          },
        },
        [
          _vm.loading
            ? _c("i", { staticClass: "far fa-spinner-third fa-spin mr-2" })
            : _vm._e(),
          _vm._v("\n    Save Changes\n  "),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-link",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("back")
            },
          },
        },
        [_vm._v("Cancel")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }